import { Injectable } from '@angular/core';
import SmartySDK from 'smartystreets-javascript-sdk';
//import * as SmartySDK from 'smartystreets-javascript-sdk'
@Injectable({
  providedIn: 'root'
})
export class SmartyAddressService {
  private client: any; // Adjust the type as needed
  /*private clientZip: any; // Adjust the type as needed*/
  constructor() {

    //const key = '202678932547259644';  // Test Address Autocomplete Pro License Key
    const key = '6588381077415448';   // MTBC Address Autocomplete Pro License Key

    const credentials = new SmartySDK.core.SharedCredentials(key);

    const clientBuilder = new SmartySDK.core.ClientBuilder(credentials).withLicenses(['us-autocomplete-pro-cloud']);

    this.client = clientBuilder.buildUsAutocompleteProClient();

    //const clientBuilderZip = new SmartySDK.core.ClientBuilder(credentials).withLicenses(['us-core-cloud']);
    // this.clientZip = clientBuilderZip.buildUsZipcodeClient();
  }
  async getAutoCompleteSuggestions(query: string, state?: string, city?: any, selected?: string, maxResults: number = 10) {
    //console.log(city);
    const lookup = new SmartySDK.usAutocompletePro.Lookup(query);
    //const state = this.globalSettingService.GetUserProfile.PracState;
    lookup.maxResults = maxResults;
    lookup.preferStates = state;
    lookup.preferCities = city;
    //lookup.preferZIPCodes = zip;

    if (selected) {
      lookup.selected = selected;
    }
    //console.log(lookup)
    try {
      const results = await this.client.send(lookup);
      return results.result;
    } catch (error) {
      console.error('Error fetching autocomplete suggestions:', error);
      throw error;
    }
  }
}

